import {
  Autocomplete,
  Box,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import EditAction from "./EditAction/EditAction";
import DeleteAction from "./DeleteAction/DeleteAction";
import { useSnapshot } from "valtio";
import { widState } from "../../Store/workdriveState";
import folderAddIcon from "../../Images/Folder-create.png";
import folderEditIcon from "../../Images/Folder-edit.png";
import folderDeleteIcon from "../../Images/Folder-delete.png";
import easyPlugins from "../../Images/easypluginz-label.png";
import CreateActionNew from "./CreateAction/CreateActionNew";
import axios from "axios";
import CreateNewAction from "./CreateAction/CreateNewAction";
import { initZoho, initZohoForCustomAction } from "../../util/zohoUtil";
import Loader from "../Overview/Loader";
import ShowError from "../../atoms/ShowError";
import { EXTENSION_IDENTIFIER } from "../../config/serviceConstant";

const ZOHO = window.ZOHO;

const customHeading = {
  fontWeight: 500,
  fontSize: "16px",
  color: "rgba(0, 0, 0, 0.87)",
};
const customDescription = {
  fontSize: "16px",
  color: "rgba(0, 0, 0, 0.6)",
};

export default function CustomActionComponents() {
  const snap = useSnapshot(widState);
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(false);
  const [settingId, setSettingId] = useState();
  const [settingSchema, setSettingSchema] = useState(null);
  const [zohoLoaded, setZohoLoaded] = useState(false);
  const [configData, setConfigData] = useState();
  const [moduleName, setModuleName] = useState(null);
  const [fieldOptions, setFieldOptions] = useState([]);
  const [page, setPage] = useState(null);
  const [existingSettingData, setExistingSettingData] = useState(null);
  const [dataCenterUrl, setDataCenterurl] = useState("");

  async function initZoho(data) {
    if (data?.configdata?.settingId) {
      setSettingId((prev) => data?.configdata?.settingId);
      const existingSettingResp = await axios.request({
        url: `${process.env.REACT_APP_ADMIN_SERVER_URL}/db/planetscale/clients/settings/${data.configdata.settingId}`,
        method: "GET",
        headers: {
          orgid: widState.orgId,
          apikey: widState.apiKey,
          datacenterurl: dataCenterUrl,
          connname: EXTENSION_IDENTIFIER,
        },
      });
      setExistingSettingData(existingSettingResp.data?.data);
    }

    const data_config = {
      apiDomain: widState.dataCenterUrl,
      entity: data?.module,
      displayName: false,
      apiName: true,
      flatten: [],
      returnValues: ["fields"],
      fetchAdditionalFieldTypes: ["entity", "lookup"],
    };

    const allFields = await axios.request({
      url: `${process.env.REACT_APP_ADMIN_SERVER_URL}/data/zoho/crm/getFieldsAndData`,
      method: "POST",
      headers: {
        orgid: widState.orgId,
        apikey: widState.apiKey,
        datacenterurl: widState.dataCenterUrl,
        connname: widState.connName,
      },
      data: data_config,
    });
    let filteredAllFieldsArray = [];
    Object.keys(allFields?.data?.fieldNames).forEach((indvModuleFieldName) => {
      allFields?.data?.fieldNames?.[indvModuleFieldName]?.forEach((item) => {
        if (
          (item.data_type === "text" ||
            item.data_type === "website" ||
            item.data_type === "textarea") &&
          item.json_type === "string"
        ) {
          if (indvModuleFieldName === data?.module) {
            filteredAllFieldsArray.push({
              lookupApiName: "",
              lookupDisplayLabel: indvModuleFieldName,
              fieldApiName: item.api_name,
              fieldDisplayLabel: item.field_label,
              type: item.data_type,
              display_label: `${item.display_label}`,
              api_name: `${item.api_name}`,
              field_label: `${item.field_label}`,
            });
          } else {
            filteredAllFieldsArray.push({
              lookupApiName: indvModuleFieldName,
              lookupDisplayLabel: indvModuleFieldName,
              fieldApiName: `${indvModuleFieldName}.${item.api_name}`,
              fieldDisplayLabel: `${indvModuleFieldName}.${item.display_label}`,
              type: item.data_type,
              display_label: `${indvModuleFieldName}.${item.display_label}`,
              api_name: `${indvModuleFieldName}.${item.api_name}`,
              field_label: `${indvModuleFieldName}.${item.field_label}`,
            });

            // filteredAllFieldsArray.push({
            //   ...item,
            //   display_label: `${indvModuleFieldName}.${item.display_label}`,
            //   api_name: `${indvModuleFieldName}.${item.api_name}`,
            //   field_label: `${indvModuleFieldName}.${item.field_label}`,
            // });
          }
        }
      });
    });
    setConfigData((prev) => data?.configdata);
    setModuleName((prev) => data?.module);
    setFieldOptions((prev) => filteredAllFieldsArray || []);
    // setLoading((prev) => false);
  }

  useEffect(() => {
    initZohoForCustomAction(async (error, extensionData) => {
      if (error || !extensionData) {
        // Set Loading false
        // Set Error Message
        setLoading((prev) => false);
        return;
      }
      const {
        serviceAuth,
        orgId,
        apiKey,
        dataCenterUrl,
        zohoLoaded,
        zohoAuth,
        serviceApiKey,
        zuid,
        zApiKey,
        dataCenter,
        data,
        showLogo,
        connName,
      } = extensionData;

      widState.connName = connName;
      widState.apiKey = apiKey;
      widState.orgId = orgId;
      widState.dataCenterUrl = dataCenterUrl;
      setDataCenterurl((prev) => dataCenterUrl);
      widState.zuid = zuid;
      widState.showLogo = showLogo;

      setZohoLoaded((prev) => zohoLoaded);
      if (zohoAuth) {
        setAuth((prev) => true);
        await initZoho(data);
      }
      setLoading((prev) => false);
    });
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!auth) {
    return <ShowError message={"You are unauthorized. Please authenticate"} />;
  }

  if (!moduleName) {
    return <ShowError />;
  }

  if (configData) {
    if (configData.actionType === "Create Action") {
      return (
        <CreateNewAction
          index={0}
          module={moduleName}
          orgid={widState.orgId}
          connname={widState.connName}
          apikey={widState?.apiKey}
          zapikey={widState?.zapikey}
          datacenterurl={dataCenterUrl}
          zuid={widState?.zuid}
          fieldOptions={fieldOptions}
          settingSchema={settingSchema}
          setSettingSchema={setSettingSchema}
          settingId={settingId}
          setSettingId={setSettingId}
        />
      );
    } else if (configData.actionType === "Edit Action") {
      return (
        <EditAction
          fieldOptions={fieldOptions}
          moduleName={moduleName}
          existingData={existingSettingData}
        />
      );
    } else if (configData.actionType === "Delete Action") {
      return (
        <DeleteAction
          moduleName={moduleName}
          fieldOptions={fieldOptions}
          existingData={existingSettingData}
        />
      );
    }
  } else {
    if (!page) {
      return (
        <Box
          sx={{
            display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
            px: 4,
            // pt: 2,
          }}
        >
          <Box>
            <Box sx={{ py: 2 }}>
              <Typography>Please select one Option</Typography>
            </Box>
            <Box
              onClick={() => setPage("create")}
              sx={{
                display: "flex",
                p: 4,
                my: 2,
                height: 40,
                alignItems: "center",
                border: "1px solid #c9cdd4",
                borderRadius: "7px",
                cursor: "pointer",
                gap: 2,
                "&:hover": {
                  bgcolor: "rgba(24, 80, 160, 0.04)",
                },
              }}
            >
              <img src={folderAddIcon} alt="folder add icon" />
              <Box>
                <Typography sx={customHeading}>
                  Create Workdrive Folder
                </Typography>
                <Typography sx={customDescription}>
                  Creates Workdrive Folder and allows you to create Nested Sub
                  Folders on Workflow Execution
                </Typography>
              </Box>
            </Box>
            <Box
              onClick={() => setPage("edit")}
              sx={{
                display: "flex",
                p: 4,
                mb: 2,
                height: 40,
                alignItems: "center",
                border: "1px solid #c9cdd4",
                borderRadius: "7px",
                cursor: "pointer",
                gap: 2,
                "&:hover": {
                  bgcolor: "rgba(24, 80, 160, 0.04)",
                },
              }}
            >
              <img src={folderEditIcon} alt="folder edit icon" />
              <Box>
                <Typography sx={customHeading}>Edit Folder Name</Typography>
                <Typography sx={customDescription}>
                  Edit Folder Name to given format on Workflow Execution
                </Typography>
              </Box>
            </Box>

            <Box
              onClick={() => setPage("delete")}
              sx={{
                display: "flex",
                p: 4,
                height: 40,
                alignItems: "center",
                border: "1px solid #c9cdd4",
                borderRadius: "7px",
                cursor: "pointer",
                gap: 2,
                "&:hover": {
                  bgcolor: "rgba(24, 80, 160, 0.04)",
                },
              }}
            >
              <img src={folderDeleteIcon} alt="folder edit icon" />
              <Box>
                <Typography sx={customHeading}>
                  Delete Workdrive Folder
                </Typography>
                <Typography sx={customDescription}>
                  Delete Workdrive Folder and all its Subfolders on Workflow
                  Execution
                </Typography>
              </Box>
            </Box>
          </Box>

          {snap?.showLogo ? (
            <Box
              sx={{
                position: "fixed",
                bottom: 10,
                right: 5,
              }}
            >
              <img
                src={easyPlugins}
                alt="Easy plugins logo"
                height={40}
                // style={{ marginLeft: "90px" }}
              />
            </Box>
          ) : (
            <></>
          )}
        </Box>
      );
    }
    if (page === "create") {
      return (
        // <CreateActionNew
        //   moduleName={moduleName}
        //   fieldOptions={fieldOptions}
        //   setPage={setPage}
        // />

        <CreateNewAction
          index={0}
          module={moduleName}
          orgid={widState.orgId}
          connname={widState.connName}
          apikey={widState?.apiKey}
          zapikey={widState?.zapikey}
          datacenterurl={dataCenterUrl}
          zuid={widState?.zuid}
          fieldOptions={fieldOptions}
          settingSchema={settingSchema}
          setSettingSchema={setSettingSchema}
          settingId={settingId}
          setSettingId={setSettingId}
        />
      );
    }
    if (page === "edit") {
      return (
        <EditAction
          fieldOptions={fieldOptions}
          moduleName={moduleName}
          setPage={setPage}
        />
      );
    }
    if (page === "delete") {
      return (
        <DeleteAction
          moduleName={moduleName}
          fieldOptions={fieldOptions}
          setPage={setPage}
        />
      );
    }
  }

  return <></>;
}
